import React from 'react';
import PropTypes from 'prop-types';
import { Link as RRLink } from 'react-router-dom';
import filterByEmptyProps from './LinkUtils';
import segment from '../../core/segment';

const { event } = segment;

function isLeftClickEvent(e) {
  return e.button === 0;
}

function isModifiedEvent(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}

/**
 * Straight port from react components.
 * We should consider refactoring this component if needed.
 */
class Link extends React.Component {
  handleClick = e => {
    if (isModifiedEvent(e) || !isLeftClickEvent(e)) {
      return;
    }
    const { trackEvent, onClick } = this.props;

    if (trackEvent) {
      const { eventType, properties, options, callback } = trackEvent;
      event(eventType, properties, options, callback);
    }

    onClick(e);
  };

  render() {
    const { dataId, className, children, id, target, to, tabIndex, role } = this.props;
    const conditionalProps = { id, target };
    const linkProps = filterByEmptyProps(conditionalProps);
    if (/^https?:\/\//.test(to)) {
      return (
        <a
          className={`link outline-0 ${className}`}
          data-id={dataId}
          href={to}
          onClick={this.handleClick}
          {...linkProps}
        >
          {children}
        </a>
      );
    }
    return (
      <RRLink
        className={`link outline-0 ${className}`}
        data-id={dataId}
        to={to}
        onClick={this.handleClick}
        role={role}
        tabIndex={tabIndex}
        {...linkProps}
      >
        {children}
      </RRLink>
    );
  }
}

Link.propTypes = {
  to: PropTypes.string.isRequired,
  dataId: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string,
  target: PropTypes.string,
  trackEvent: PropTypes.shape({
    eventType: PropTypes.string.isRequired,
    properties: PropTypes.object,
    options: PropTypes.object,
    callback: PropTypes.func,
  }),
  tabIndex: PropTypes.string,
  role: PropTypes.string,
};

Link.contextTypes = {
  history: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  analytics: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

Link.defaultProps = {
  dataId: 'link',
  onClick: () => {},
  id: '',
  className: 'blue hover-black f7',
  trackEvent: null,
  target: '',
  tabIndex: undefined,
  role: undefined,
};

export default Link;
